export default "skymp5-front/4f36a9562e8b6cedc42e287c176acdf2.png";